// removed by extract-text-webpack-plugin
module.exports = {"header":"index_1r8lRSP","red_block":"index_15S57HO"};


//////////////////
// WEBPACK FOOTER
// ./src/component/subheader/index.css
// module id = 905
// module chunks = 0